// extracted by mini-css-extract-plugin
export default {"hero":"hero-module--hero--3M3h6","bottomRightBG":"hero-module--bottomRightBG--1tjoW","topLeftBG":"hero-module--topLeftBG--1T2LP"};